// Business hours helpers — spec 2026-02-XX rev5 (Feb 2026).
//
// Miroir JS du helper Python `services/business_hours.py`. Utilisé
// côté frontend pour calculer un délai visible EN LIVE ("Pas vu · Xh")
// qui exclut les nuits et week-ends. La logique doit rester alignée
// avec le backend (qui fige `reaction_delay_seconds` au 1ᵉʳ read).
//
// Convention Vertec (Alger, UTC+1 sans DST) :
//   • Jours ouvrés : Dimanche (getDay()=0) → Jeudi (=4).
//   • Vendredi (=5) et Samedi (=6) = week-end.
//   • Heures ouvrées : 08h → 17h (fuseau local Alger, UTC+1).

const ALGIERS_TZ_OFFSET_MIN = 60; // UTC+1
const BUSINESS_WEEKDAYS = new Set([0, 1, 2, 3, 4]); // Sun, Mon, Tue, Wed, Thu (JS Date.getDay())
const BUSINESS_START_H = 8;
const BUSINESS_END_H = 17;

/** Convertit un ms UTC en "instant local Alger" (Date représentant l'heure murale d'Alger). */
function toAlgiersLocal(msUtc) {
  // Alger = UTC+1 → on shift le timestamp de +60 min, puis on utilise les
  // getters UTC pour obtenir l'heure "murale" locale.
  return new Date(msUtc + ALGIERS_TZ_OFFSET_MIN * 60_000);
}

/** Retourne le nb de secondes ouvrées écoulées entre `aMs` et `bMs` (ms UTC). */
export function businessSecondsBetween(aMs, bMs) {
  if (!aMs || !bMs || bMs <= aMs) return 0;
  const la = toAlgiersLocal(aMs);
  const lb = toAlgiersLocal(bMs);
  let total = 0;
  // Itère jour par jour local Alger.
  const day = new Date(Date.UTC(la.getUTCFullYear(), la.getUTCMonth(), la.getUTCDate()));
  const lastDay = new Date(Date.UTC(lb.getUTCFullYear(), lb.getUTCMonth(), lb.getUTCDate()));
  while (day <= lastDay) {
    if (BUSINESS_WEEKDAYS.has(day.getUTCDay())) {
      const openMs = day.getTime() + BUSINESS_START_H * 3600_000;
      const closeMs = day.getTime() + BUSINESS_END_H * 3600_000;
      const segStart = Math.max(la.getTime(), openMs);
      const segEnd = Math.min(lb.getTime(), closeMs);
      if (segEnd > segStart) {
        total += Math.floor((segEnd - segStart) / 1000);
      }
    }
    day.setUTCDate(day.getUTCDate() + 1);
  }
  return total;
}
